import React from 'react';
import './App.css';
import KebabHero from './components/KebabHero';
import KebabGallery from './components/KebabGallery';
import KebabContact from './components/KebabContact';

function App() {
  return (
    <div className="App">
      <section id="hero">
        <KebabHero />
      </section>
      <section id="gallery">
        <KebabGallery />
      </section>
      <section id="contact">
        <KebabContact />
      </section>
    </div>
  );
}

export default App;